import React, { useState, useEffect } from 'react';
import { DatePicker, InputNumber, Form, Input, Select } from 'antd';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import locale from 'antd/es/date-picker/locale/ru_RU';

dayjs.locale('ru');

const { Option } = Select;

export default function NovoeZasedaniePravleniyaFederatsii(props) {
    const { auth } = props;
    const [city, setCity] = useState([]);

    useEffect(() => {
        auth.fetch('/api/query/City?s-name').then(res => {
            if (res && res.data) {
                setCity(res.data);
            }
        });
    }, []);

    const options = city.map(i => (
        <Option key={i.ID} value={i.ID}>{i.name}</Option>
    ));
    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                neobkhodimiiKvorum: 50,
                dataZasedaniya: dayjs()
            }}
        >
            <Form.Item
                name={"nomerProtokolaZasedaniya"}
                label={"Номер протокола заседания"}
                rules={[{ required: true, message: 'Укажите номер протокола заседания!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={"dataZasedaniya"}
                label={"Дата заседания"}
                rules={[{ required: true, message: 'Укажите дату заседания!' }]}
            >
                <DatePicker locale={locale} />
            </Form.Item>
            <Form.Item
                name={"mestoProvedeniyaZasedaniyaID"}
                label={"Место проведения заседания"}
                rules={[{ required: true, message: 'Укажите место проведения заседания!' }]}
            >
                <Select showSearch
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }>
                    {options}
                </Select>
            </Form.Item>
            <Form.Item
                name={"neobkhodimiiKvorum"}
                label={"Необходимый кворум"}
                rules={[{ required: true, message: 'Укажите необходимый кворум!' }]}
            >
                <InputNumber min={0}
                    max={100}
                    formatter={value => `${value}%`}
                    parser={value => Number.parseFloat(value.replace('%', ''))}
                    precision={2}
                    step={0.05}
                    style={{ width: "50%" }} />
            </Form.Item>
        </Form>
    );
}
